import PlaygroundAuthType from "../../../playgroundAuthType";
import sanitizeName from "./sanitizeName";
import OAUTH_NOTE from "./oauthNote";

const getBoltAiInstructions = (playground, bearerToken, mcpServerUrl) => {
  const oauthNote =
    playground.authType === PlaygroundAuthType.OAUTH ? OAUTH_NOTE : "";
  let codeSnippet = `{
  "mcpServers": {
    "${sanitizeName(playground.name)}": {     
      "command": "npx",
      "args": ["mcp-remote", "${mcpServerUrl}"]
    }
  }
}`;

  if (playground.authType === "BEARER_TOKEN") {
    codeSnippet = `{
  "mcpServers": {
    "${sanitizeName(playground.name)}": {
      "command": "npx",
      "args": ["mcp-remote", "${mcpServerUrl}", "--header", "Authorization:Bearer ${
      bearerToken ? bearerToken : "<YOUR_API_KEY>"
    }"]    
    }
  }
}`;
  }

  const result = `

${oauthNote}1. Open Settings and go to the "Plugins" section.

![](/app/images/screens/boltai_setup_1.png)

2. Click the plus button and open the editor with the MCP server configuration.

![](/app/images/screens/boltai_setup_2.png)

Copy and paste the following JSON code into the editor:

\`\`\`json
${codeSnippet}
\`\`\`

3. Click Save Changes.

For further details, see [the official documentation here](https://docs.boltai.com/docs/plugins/mcp-servers).
`;
  return result;
};

export default getBoltAiInstructions;
